import { Feedback } from "src/components/common/Feedback"
import { routes } from "src/config/routes"
import { useIsClient } from "src/hooks/useIsClient"
import { localizeText } from "src/localization/utils"

export type ErrorFeedbackProps = {
  title?: string
  description?: string
  backHref?: string
  backLabel?: string
}

export function ErrorFeedback({ title, description, backHref, backLabel }: ErrorFeedbackProps) {
  const isClient = useIsClient()

  // Due to difficult access to the country code, we can't localize the text on
  // the server.
  if (!isClient) {
    return null
  }

  const T = localizeText(text)

  return (
    <Feedback
      title={title || T.title}
      description={description || T.description}
      linkHref={backHref || routes.home}
      linkText={backLabel || T.goHome}
    />
  )
}

const de = {
  title: "Fehler",
  description: "Es tut uns leid, ein Fehler ist aufgetreten.",
  goHome: "Zur Startseite",
}

const en: typeof de = {
  title: "Error",
  description: "Sorry, an error occurred.",
  goHome: "Go to frontpage",
}

const text = { de, en }
